var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.546875,
    y: 0.484848,
    width: 95.2396,
    height: 95.2396,
    rx: 20.3547,
    fill: "#5E1B0C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1106_11036)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.377,
    y: 25.8247,
    width: 52.015,
    height: 37.1535,
    rx: 3.71536,
    fill: "#F8F7F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.8066,
    y: 33.102,
    width: 52.015,
    height: 37.1535,
    rx: 3.71536,
    fill: "#FE6533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8203 40.7778V44.4496",
    stroke: "#F8F7F2",
    strokeWidth: 3.71536,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8203 59.0141V62.5862",
    stroke: "#F8F7F2",
    strokeWidth: 3.71536,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4092 44.8247H49.023C47.985 44.8247 46.9896 45.1983 46.2556 45.8634C45.5217 46.5285 45.1094 47.4306 45.1094 48.3712C45.1094 49.3117 45.5217 50.2138 46.2556 50.8789C46.9896 51.544 47.985 51.9176 49.023 51.9176H54.6138C55.6518 51.9176 56.6472 52.2913 57.3811 52.9564C58.1151 53.6215 58.5274 54.5235 58.5274 55.4641C58.5274 56.4047 58.1151 57.3068 57.3811 57.9719C56.6472 58.6369 55.6518 59.0106 54.6138 59.0106H45.1094",
    stroke: "#F8F7F2",
    strokeWidth: 3.71536,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1106_11036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.4457,
    height: 59.4457,
    fill: "white",
    transform: "translate(18.3809 18.3208)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/Finance.c1a506b94d1ad4e3cf570606f0f2fa22.svg";
export { ForwardRef as ReactComponent };